import "./LoadingSpinner.css";
import { UpdateIcon } from "@radix-ui/react-icons";

const LoadingSpinner = () => {
  return (
    <div className={`flex flex-row main-container`}>
      <div className={"w-[50%] h-[50%] m-auto"}>
        <UpdateIcon className="spinner" />
      </div>
    </div>
  );
};

export default LoadingSpinner;